import AcButton from './AcButton.vue';
import AcInput from './AcInput.vue';
import AcRadio from './AcRadio.vue';
import AcNotice from './AcNotice.vue';

export default {
    'ac-button': AcButton,
    'ac-input': AcInput,
    'ac-radio': AcRadio,
    'ac-notice': AcNotice
}



// WEBPACK FOOTER //
// ./admin/src/js/components/all.js